const allowedTemplates = [
  "index",
  "collection",
  "product",
  "checkout",
  "order",
];

// if (allowedTemplates.includes(window.shopifyTemplateCheck)) {}
document.addEventListener("click", function (event) {
  let element = event.target;
  function extractClickData(el) {
    return {
      click_element: el.tagName?.toLowerCase() || null,
      click_id: el.id || null,
      click_class: el.className || null,
      click_target: el.getAttribute?.("target") || null,
      click_text: el.innerText?.trim().slice(0, 100) || null,
      click_url: el.getAttribute?.("href") || el.getAttribute?.("src") || null,
    };
  }

  let clickData = extractClickData(element);

  // Check if all key fields are null or empty — if so, move up the DOM
  const isEmpty = (data) => {
    return (
      !data.click_id &&
      (typeof data.click_class === "object" || !data.click_class) &&
      !data.click_text &&
      !data.click_url
    );
  };

  while (isEmpty(clickData) && element.parentElement) {
    element = element.parentElement;
    clickData = extractClickData(element);
  }

  // Add the GA4 event name
  clickData.event = "all_click";

  if (window.gtag) {
    gtag("event", "all_click", clickData);
  }

  // Optional: Debug log
  // console.log("GA4 Click Event:", clickData);
  // console.log(`Current Shopify template: ${shopifyTemplateCheck}`);
});

document.addEventListener("DOMContentLoaded", function () {
  const tooltipDivs = document.querySelectorAll(".tool-tip-trigger__title");

  tooltipDivs.forEach((div) => {
    div.addEventListener("click", function (event) {
      const el = event.target;
      if (el.innerText?.trim().slice(0, 100) === "Size Guide") {
        const clickData = {
          event: "all_click",
          click_element: el.tagName?.toLowerCase() || null,
          click_id: el.id || null,
          click_class: el.className || null,
          click_target: el.getAttribute?.("target") || null,
          click_text: el.innerText?.trim().slice(0, 100) || null,
          click_url:
            el.getAttribute?.("href") || el.getAttribute?.("src") || null,
        };
      }
      if (window.gtag) {
        gtag("event", "all_click", clickData);
      }
    });
  });
});
